// extracted by mini-css-extract-plugin
export default {"projectMini":"ProjectMini_projectMini__hwdZm","projectNameAndDesc":"ProjectMini_projectNameAndDesc__78mWg"};